import { useState, useEffect } from 'react';
import { useUser } from '../Auth/AuthContext';
import {
    Typography, Box, Grid,
    Select, MenuItem, FormControl, InputLabel, LinearProgress, Avatar
} from '@mui/material';
import Icon from '../Shared/Icon';
import Title from '../Shared/Title';

const FormSelect = props => {
    const user = useUser();
    const [options, setOptions] = useState(props.options)
    useEffect(() => {
        setOptions(props.options)
    }, [props]);

    return (
        <FormControl variant='standard' fullWidth
        >
            {props.label && <InputLabel shrink={props.header || props.value !== undefined || false}>{props.label}</InputLabel>}

            {options ?
                <Select
                    name={props.name}
                    value={props.value}
                    onChange={props.handler}
                    disabled={user?.role != "Admin" || props.disabled}
                    disableUnderline={props.disableUnderline}
                    IconComponent={props.hideArrow && (() => { })}
                // renderValue={() => <FormOption option={props.options.find(x => x.value === props.value)} selected />}
                >
                    <MenuItem key={-1} value=''>(none)</MenuItem>
                    {props.options && props.options.map((option, key) => {
                        return (
                            <MenuItem
                                key={key}
                                value={option.value}
                            >
                                <Title
                                    row
                                    disabled
                                    systems={option.system && [option.system]}
                                    icons={option.icon && [option.icon]}
                                    label={option.label}
                                />
                            </MenuItem>
                        )
                    })}
                </Select>
                :
                <Grid item xs={12} sx={{ '& .MuiLinearProgress-root': { top: '1rem' } }}><LinearProgress /></Grid>
            }
        </FormControl>
    )
}
export default FormSelect;